import { render, staticRenderFns } from "./TableRisorse.vue?vue&type=template&id=ae21cf7e"
import script from "./TableRisorse.vue?vue&type=script&lang=js"
export * from "./TableRisorse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports